const humburger = document.querySelector('.humburger-header');
if(humburger != null) {
	humburger.addEventListener('click', ()=>{
		const menu = document.querySelector('.header-menu');
		menu.classList.toggle('active');
	})
}

const humburgerFooter = document.querySelector('.humburger-footer');
if(humburgerFooter != null) {
	humburgerFooter.addEventListener('click', ()=>{
		const menu = document.querySelector('.footer-menu');
		menu.classList.toggle('active');
	})
}



// WEBPACK FOOTER //
// ./scripts/mobile-menu.js